import moment from 'moment';
import { SCAN_TYPE } from '../../constants';
import { useMemo } from 'react';
import { Card, CardBody } from 'reactstrap';
import { Link } from 'react-router';

const typeToText = {
  draftTime: "Nháp",
  canceledTime: "Đã huỷ",
  createdTime: "Vừa đặt",
  confirmedTime: "Xác nhận",
  packingTime: "Soạn hàng",
  inPackage: "Đóng gói",
  toShipper: "Giao hàng",
  checkPackageTime: "Kiểm hàng",
  finishTime: "Hoàn thành",
  waitingPay: "Chờ trả tiền",
  successfulPay: "Đã thanh toán",
  waitingExportVAT: "Chờ xuất hoá đơn",
  successfulExportVAT: "Xuất hoá đơn thành công"
}

export const CardInfoGetScanInventory = ({ data }) => {
  const { billId, message, status } = useMemo(() => {
    const temp = {
      billId: data.billId,
      status: 1,
      message: []
    }
    if (data.draftTime) {
      temp.message.push({ msg: `${typeToText.draftTime}:${moment(data.draftTime).format('DD-MM-YYYY HH:mm:ss')}`, color: 'success', scanAt: moment(data.draftTime) })
    }

    if (data.createdTime) {
      temp.message.push({ msg: `${typeToText.createdTime}:${moment(data.createdTime).format('DD-MM-YYYY HH:mm:ss')}`, color: 'success', scanAt: moment(data.createdTime) })
    }

    if (data.confirmedTime) {
      temp.message.push({ msg: `${typeToText.confirmedTime}:${moment(data.confirmedTime).format('DD-MM-YYYY HH:mm:ss')}`, color: 'success', scanAt: moment(data.confirmedTime) })
    }

    if (data.packingTime) {
      temp.message.push({ msg: `${typeToText.packingTime}:${moment(data.packingTime).format('DD-MM-YYYY HH:mm:ss')}`, color: 'success', scanAt: moment(data.packingTime) })
    }
    if (data.inPackage) {
      temp.message.push({ msg: `${typeToText.inPackage}:${moment(data.inPackage).format('DD-MM-YYYY HH:mm:ss')}`, color: 'success', scanAt: moment(data.inPackage) })
    }

    if (data.toShipper) {
      temp.message.push({ msg: `${typeToText.toShipper}:${moment(data.toShipper).format('DD-MM-YYYY HH:mm:ss')}`, color: 'success', scanAt: moment(data.toShipper) })
    }

    if (data.checkPackageTime) {
      temp.message.push({ msg: `${typeToText.checkPackageTime}:${moment(data.checkPackageTime).format('DD-MM-YYYY HH:mm:ss')}`, color: 'success', scanAt: moment(data.checkPackageTime) })
    }
    if (data.finishTime) {
      temp.message.push({ msg: `${typeToText.finishTime}:${moment(data.finishTime).format('DD-MM-YYYY HH:mm:ss')}`, color: 'success', scanAt: moment(data.finishTime) })
    }

    if (data.waitingPay) {
      temp.message.push({ msg: `${typeToText.waitingPay}:${moment(data.waitingPay).format('DD-MM-YYYY HH:mm:ss')}`, color: 'success', scanAt: moment(data.waitingPay) })
    }

    if (data.successfulPay) {
      temp.message.push({ msg: `${typeToText.successfulPay}:${moment(data.successfulPay).format('DD-MM-YYYY HH:mm:ss')}`, color: 'success', scanAt: moment(data.successfulPay) })
    }

    if (data.waitingExportVAT) {
      temp.message.push({ msg: `${typeToText.waitingExportVAT}:${moment(data.waitingExportVAT).format('DD-MM-YYYY HH:mm:ss')}`, color: 'success', scanAt: moment(data.waitingExportVAT) })
    }

    if (data.successfulExportVAT) {
      temp.message.push({ msg: `${typeToText.successfulExportVAT}:${moment(data.successfulExportVAT).format('DD-MM-YYYY HH:mm:ss')}`, color: 'success', scanAt: moment(data.successfulExportVAT) })
    }

    if (data.canceledTime) {
      temp.message.push({ msg: `${typeToText.canceledTime}:${moment(data.canceledTime).format('DD-MM-YYYY HH:mm:ss')}`, color: 'danger', scanAt: moment(data.canceledTime) })
    }

    temp.message = temp.message.sort((a, b) => a.scanAt.isAfter(b.scanAt) ? 1 : -1)
    const scanDuplicate = [];
    data.BillScanInventoryHistories.forEach(e => {
      if (e.scanType === SCAN_TYPE.DUPLICATE) {
        scanDuplicate.push({ msg: `[Trùng] ${typeToText[e.type]}:${moment(e.createdAt).format('DD-MM-YYYY HH:mm:ss')}`, color: 'warning', scanAt: moment(e.createdAt) });
      }
      if (e.scanType === SCAN_TYPE.CHANGE_STATUS_ERROR) {
        scanDuplicate.push({ msg: `[T.Thái] ${typeToText[e.type]}:${moment(e.createdAt).format('DD-MM-YYYY HH:mm:ss')}`, color: 'danger', scanAt: moment(e.createdAt) });
      }
    })
    temp.message = [...temp.message, ...scanDuplicate.sort((a, b) => a.scanAt.isAfter(b.scanAt) ? 1 : -1)]
    return temp;
  }, [data])
  return <Card className="border border-primary">
    <CardBody>
      <h6 className="d-flex align-items-center">
        {billId}
        {billId && (
          <Link to={`/oder-manager/${billId}`} className="ms-2 text-primary" title="Xem chi tiết đơn hàng">
            <i className="bx bx-edit font-size-16"></i>
          </Link>
        )}
      </h6>
      <span>Tình trạng: <strong className={status ? "text-success" : 'text-danger'}>
        <ul>
          {message.filter(e => e.color === 'success').map((e, i) => <li className={`text-${e.color}`} key={i}>{e.msg}</li>)}
        </ul>
        <hr />
        <ul>
          {message.filter(e => e.color !== 'success').map((e, i) => <li className={`text-${e.color}`} key={i}>{e.msg}</li>)}
        </ul>
      </strong></span>
    </CardBody>
  </Card>
}